import React, { useState, useEffect } from "react";
import { Typography, Tag } from "antd";
import SubscriptionCard from "../../components/suscriptionBilling/SubscriptionCard";
import PromoCard from "../../components/suscriptionBilling/PromoCard";
import PaymentInfoCard from "../../components/suscriptionBilling/PaymentInfoCard";
import BillingHistoryCard from "../../components/suscriptionBilling/BillingHistoryCard";
import { render } from "react-dom";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getBillingHistoryApi } from "../../services/payment.service";
import PageLoader from "../../components/common/loader/pageLoader";

const { Title, Text, Link } = Typography;

const SubscriptionPage: React.FC = () => {
  // Define columns for billing history table

  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});

  useEffect(() => {
    fetchBillingData();
  }, []);

  const fetchBillingData = () => {
    setLoading(true);
    dispatch(
      getBillingHistoryApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setData(data);
        },
        unAunthenticatedCallback: () => {
          // handle unauthenticated case here if needed
        },
      })
    );
  };

  const columns = [
    {
      title: "Invoice ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <Text>{date}</Text>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount: string) => <Text>{`$${amount}`}</Text>,
    },
    {
      title: "Payment Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <Tag
          style={{ textTransform: "capitalize" }}
          color={status === "successful" ? "green" : "red"}
        >
          {status}
        </Tag>
      ),
    },
  ];

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="suscription-billing-page">
      <SubscriptionCard
        data={data?.current_subscription_plan}
        subscription_status={data?.subscription}
      />
      {/* <PromoCard
        title="Upgrade to Yearly Plan"
        description="Get unlimited access to all features"
        buttonText="Upgrade Now"
        onClick={() => console.log("Upgrade clicked")}
      /> */}
      <PaymentInfoCard data={data?.payment_info} />
      <BillingHistoryCard columns={columns} data={data?.billings} />
    </div>
  );
};

export default SubscriptionPage;
